// extracted by mini-css-extract-plugin
module.exports = {"version":"VersionIndicator_version__10IIP","collapsed":"VersionIndicator_collapsed__1hWHZ"};